import {useContext, useEffect} from "react";
import { AuthContext } from "context";
import AuthService from "services/auth-service";

const Logout = ({ children }) => {
  const authContext = useContext(AuthContext);

  // This had no dependency array, so it re-ran on every render of this
  // component instead of once on mount. authContext.logout() calls
  // setIsAuthenticated, so any re-render before the redirect to
  // /auth/login unmounts this component (a slow network response, a
  // StrictMode double-invoke, ...) fires the effect again, setting state
  // again, forcing another render — the exact "Maximum update depth
  // exceeded" loop.
  useEffect(() => {
    (async () => {
      await AuthService.logout();
      authContext.logout();
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <>{children}</>;
};

export default Logout;
